import awards from "../../shared/es.awards";
import branded_quotes from "../../shared/es.branded-quotes";
import verticals from "./es-education-secondary.verticals";
const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};
export default ({ page, strings }) => {
    switch (page) {
        case "es-education-secondary-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contacto | Rosetta Stone",
                    meta_description: "Las soluciones de aprendizaje de idiomas de Rosetta Stone para la educación superior brinda a los estudiantes acceso en línea al instante para aprender inglés y otros idiomas internacionales. Consulte precios.",
                    canonical_url: "https://www.rosettastone.es/educacion-superior/contacto/",
                    lang: "es"
                },
                awards: {
                    visible: true,
                    title: {
                        content: strings.awards_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: awards({ strings })
                },
                branded_quotes: {
                    visible: true,
                    title: {
                        content: strings.branded_quotes_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: branded_quotes({ strings })
                },
                verticals: {
                    visible: true,
                    title: {
                        content: strings.verticals_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: verticals({ strings })
                }
            };
        case "es-education-secondary-home":
            return {
                page,
                helmet: {
                    meta_title: "El aprendizaje de idiomas para la educación superior | Rosetta Stone",
                    meta_description: "Las soluciones de aprendizaje de idiomas de Rosetta Stone para la educación superior brinda a los estudiantes acceso en línea al instante para aprender inglés y otros idiomas internacionales. Consulte precios.",
                    canonical_url: "https://www.rosettastone.es/educacion-superior/",
                    lang: "es"
                },
                awards: {
                    visible: true,
                    title: {
                        content: strings.awards_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: awards({ strings })
                },
                branded_quotes: {
                    visible: true,
                    title: {
                        content: strings.branded_quotes_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: branded_quotes({ strings })
                },
                verticals: {
                    visible: true,
                    title: {
                        content: strings.verticals_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: verticals({ strings })
                }
            };
        case "es-education-secondary-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "Centro de recursos | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.es/educacion-superior/recursos/",
                    lang: "es"
                },
                awards: {
                    visible: true,
                    title: {
                        content: strings.awards_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: awards({ strings })
                },
                branded_quotes: {
                    visible: true,
                    title: {
                        content: strings.branded_quotes_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: branded_quotes({ strings })
                },
                verticals: {
                    visible: true,
                    title: {
                        content: strings.verticals_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: verticals({ strings })
                }
            };
        case "es-education-secondary-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "es"
                },
                awards: {
                    visible: true,
                    title: {
                        content: strings.awards_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: awards({ strings })
                },
                branded_quotes: {
                    visible: true,
                    title: {
                        content: strings.branded_quotes_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: branded_quotes({ strings })
                },
                verticals: {
                    visible: true,
                    title: {
                        content: strings.verticals_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: verticals({ strings })
                }
            };
        case "es-education-secondary-404":
            return {
                page,
                helmet: {
                    meta_title: "Sitio no encontrado | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.es/educacion-superior/404",
                    lang: "es"
                },
                awards: {
                    visible: true,
                    title: {
                        content: strings.awards_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: awards({ strings })
                },
                branded_quotes: {
                    visible: true,
                    title: {
                        content: strings.branded_quotes_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: branded_quotes({ strings })
                },
                verticals: {
                    visible: true,
                    title: {
                        content: strings.verticals_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: verticals({ strings })
                }
            };
        default:
            return null;
    }
};
